export const RESET: 'CONNECTION/RESET' = 'CONNECTION/RESET';
export const CHUNK_LOADING_ERROR: 'CONNECTION/CHUNK_LOADING_ERROR' = 'CONNECTION/CHUNK_LOADING_ERROR';
export const CHANGE_NETWORK_STATE: 'CONNECTION/CHANGE_NETWORK_STATE' = 'CONNECTION/CHANGE_NETWORK_STATE';
export const NETWORK_SAVE_REQUEST_ERROR: 'CONNECTION/NETWORK_SAVE_REQUEST_ERROR' =
	'CONNECTION/NETWORK_SAVE_REQUEST_ERROR';
export const NETWORK_INTERCEPTION_ERROR: 'CONNECTION/NETWORK_INTERCEPTION_ERROR' =
	'CONNECTION/NETWORK_INTERCEPTION_ERROR';
export const NETWORK_FETCH_REQUEST_ERROR: 'CONNECTION/NETWORK_FETCH_REQUEST_ERROR' =
	'CONNECTION/NETWORK_FETCH_REQUEST_ERROR';
export const NETWORK_REQUEST_ERROR: 'CONNECTION/NETWORK_REQUEST_ERROR' = 'CONNECTION/NETWORK_REQUEST_ERROR';
